/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_How_Trial_WorksInputs */

const en_btn_how_trial_works = /** @type {(inputs: Btn_How_Trial_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How Trial Works`)
};

const ar_btn_how_trial_works = /** @type {(inputs: Btn_How_Trial_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كيف تعمل النسخة التجريبية`)
};

const de_btn_how_trial_works = /** @type {(inputs: Btn_How_Trial_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie der Prozess funktioniert`)
};

const es_btn_how_trial_works = /** @type {(inputs: Btn_How_Trial_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo funciona el periodo de prueba`)
};

const fr_btn_how_trial_works = /** @type {(inputs: Btn_How_Trial_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment fonctionne la période d'essai`)
};

const it_btn_how_trial_works = /** @type {(inputs: Btn_How_Trial_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come funziona la prova`)
};

const ja_btn_how_trial_works = /** @type {(inputs: Btn_How_Trial_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トライアルの仕組み`)
};

const ko_btn_how_trial_works = /** @type {(inputs: Btn_How_Trial_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`체험판 이용법 보기`)
};

const pt_br_btn_how_trial_works = /** @type {(inputs: Btn_How_Trial_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como funciona o teste grátis`)
};

const ru_btn_how_trial_works = /** @type {(inputs: Btn_How_Trial_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О пробной версии`)
};

const th_btn_how_trial_works = /** @type {(inputs: Btn_How_Trial_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การทดลองใช้เป็นอย่างไร`)
};

const tr_btn_how_trial_works = /** @type {(inputs: Btn_How_Trial_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deneme Sürümü Nedir`)
};

const zh_cn_btn_how_trial_works = /** @type {(inputs: Btn_How_Trial_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解如何试用`)
};

const zh_tw_btn_how_trial_works = /** @type {(inputs: Btn_How_Trial_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解如何試用`)
};

/**
* | output |
* | --- |
* | "How Trial Works" |
*
* @param {Btn_How_Trial_WorksInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_how_trial_works = /** @type {((inputs?: Btn_How_Trial_WorksInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_How_Trial_WorksInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_how_trial_works(inputs)
	if (locale === "ar") return ar_btn_how_trial_works(inputs)
	if (locale === "de") return de_btn_how_trial_works(inputs)
	if (locale === "es") return es_btn_how_trial_works(inputs)
	if (locale === "fr") return fr_btn_how_trial_works(inputs)
	if (locale === "it") return it_btn_how_trial_works(inputs)
	if (locale === "ja") return ja_btn_how_trial_works(inputs)
	if (locale === "ko") return ko_btn_how_trial_works(inputs)
	if (locale === "pt_br") return pt_br_btn_how_trial_works(inputs)
	if (locale === "ru") return ru_btn_how_trial_works(inputs)
	if (locale === "th") return th_btn_how_trial_works(inputs)
	if (locale === "tr") return tr_btn_how_trial_works(inputs)
	if (locale === "zh_cn") return zh_cn_btn_how_trial_works(inputs)
	return zh_tw_btn_how_trial_works(inputs)
});